import { FC, useEffect } from 'react';
import { IonContent } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { Modal } from '../components/Modal';
import { BeeChatState } from './BeeChatState';
import { ActiveChatView } from './ActiveChatView';
import { ConversationListView } from './ConversationListView';

const useStyles = createUseStyles({
    outerContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
    },
    slidingContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        width: '200%',
        height: '100%',
        transition: 'left 300ms ease-in-out'
    },
    showList: {
        left: 0
    },
    showChat: {
        left: '-100%'
    },
    slidePanel: {
        width: '50%',
        minWidth: '50%',
        height: '100%',
        flexShrink: 0,
        overflow: 'auto'
    }
});

interface BeeChatModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const BeeChatModal: FC<BeeChatModalProps> = ({ isOpen, onClose }) => {
    const classes = useStyles();
    const chatState = useInstance(BeeChatState);
    useSubscription(() => chatState);

    const { currentView } = chatState.state;

    useEffect(() => {
        if (isOpen) {
            // Always start a new conversation when modal opens
            chatState.startNewConversation();
            // Load existing chats from API for the list
            chatState.loadChats();
        }
    }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleBack = () => {
        if (currentView === 'chat') {
            chatState.showConversationList();
        }
    };

    const handleClose = () => {
        onClose();
    };

    const getTitle = (): string => {
        return "Innerhive's BeeLine";
    };

    const containerClass = `${classes.slidingContainer} ${currentView === 'chat' ? classes.showChat : classes.showList}`;

    return (
        <Modal
            isOpen={isOpen}
            titleColor="secondary"
            buttonColor="light"
            title={getTitle()}
            data-id="bea-chat-modal"
            closeHandler={handleClose}
            backHandler={currentView === 'chat' ? handleBack : undefined}
            maximizeDesktopHeight
        >
            <IonContent scrollY={false}>
                <div className={classes.outerContainer}>
                    <div className={containerClass}>
                        <div className={classes.slidePanel}>
                            <ConversationListView />
                        </div>
                        <div className={classes.slidePanel}>
                            <ActiveChatView />
                        </div>
                    </div>
                </div>
            </IonContent>
        </Modal>
    );
};
